import configureStore from 'data/configureStore'
// import { syncHistoryWithStore } from "react-router-redux"
const store = configureStore()
export default store
